import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Navigate, useLocation } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * ProtectedRoute — checks GET /api/auth/me on mount.
 * - 200 → renders children
 * - 401 → redirects to /login
 * - Loading → shows full-page spinner
 */
export default function ProtectedRoute({ children }) {
  const [status, setStatus] = useState('loading'); // 'loading' | 'ok' | 'unauth'
  const location = useLocation();

  useEffect(() => {
    axios
      .get(`${API}/api/auth/me`, { withCredentials: true })
      .then(() => setStatus('ok'))
      .catch(err => {
        if (err.response?.status === 401) {
          setStatus('unauth');
        } else {
          // Network error or unexpected — treat as unauthenticated
          setStatus('unauth');
        }
      });
  }, []);

  if (status === 'loading') {
    return (
      <div
        data-testid="protected-route-loading"
        style={{
          display: 'flex', height: '100vh',
          alignItems: 'center', justifyContent: 'center',
          background: '#F4F3F5', flexDirection: 'column', gap: 16,
        }}
      >
        <div
          style={{
            width: 36, height: 36, borderRadius: '50%',
            border: '3px solid #e2e8f0',
            borderTopColor: '#194449',
            animation: 'spin 0.7s linear infinite',
          }}
        />
        <span style={{ color: '#6b7280', fontFamily: '"DM Sans", sans-serif', fontSize: 14 }}>
          Verifying session…
        </span>
      </div>
    );
  }

  if (status === 'unauth') {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
